import { IssueSeverityEnum } from '@issuemanager/constants';
import { z } from 'zod';

export const slaSchema = z.object({
  id: z.string(),
  issueTypeConfigId: z.string(),
  severity: z.nativeEnum(IssueSeverityEnum),
  slaDays: z.number().int().positive(),
  maxDueDate: z.number().int().positive(),
  escalationDays: z.number().int().positive(),
  reminderDays: z.array(z.number().int().positive()),
  createdBy: z.string(),
  updatedBy: z.string(),
  deletedBy: z.string().nullable(),
  createdAt: z.number().transform((date) => new Date(date).toISOString()),
  updatedAt: z.number().transform((date) => new Date(date).toISOString()),
  deletedAt: z
    .number()
    .transform((date) => new Date(date).toISOString())
    .nullable(),
});

export const slaBaseSchema = z.object({
  id: z.string(),
  issue_type_config_id: z.string(),
  severity: z.nativeEnum(IssueSeverityEnum),
  sla_days: z.number().int().positive(),
  max_due_date: z.number().int().positive(),
  escalation_days: z.number().int().positive(),
  reminder_days: z.array(z.number().int().positive()),
  created_by: z.string(),
  updated_by: z.string(),
  deleted_by: z.string().nullable(),
  created_at: z.number().transform((date) => new Date(date).toISOString()),
  updated_at: z.number().transform((date) => new Date(date).toISOString()),
  deleted_at: z
    .number()
    .transform((date) => new Date(date).toISOString())
    .nullable(),
});

export const slaDatabaseSchema = slaBaseSchema.transform((data) =>
  transformDBtoJS(data),
);

export type SLA = z.infer<typeof slaSchema>;

export type SLAEntity = z.infer<typeof slaDatabaseSchema>;

export function transformDBtoJS(data: z.infer<typeof slaBaseSchema>) {
  return {
    id: data.id,
    issueTypeConfigId: data.issue_type_config_id,
    severity: data.severity,
    slaDays: data.sla_days,
    maxDueDate: data.max_due_date,
    escalationDays: data.escalation_days,
    reminderDays: data.reminder_days,
    createdBy: data.created_by,
    updatedBy: data.updated_by,
    deletedBy: data.deleted_by,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    deletedAt: data.deleted_at,
  };
}
